import { render, staticRenderFns } from "./CustomersControl.vue?vue&type=template&id=00a7d20a&scoped=true"
import script from "./CustomersControl.vue?vue&type=script&lang=js"
export * from "./CustomersControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a7d20a",
  null
  
)

export default component.exports